import React from 'react';

import FormattedOrganizationMembershipCode from '@/components/ui/formats/FormattedOrganizationMembershipCode';
import GradeClassNumberLabel from '@/components/ui/formats/GradeClassNumberLabel';
import { type RelatedParent, type Student } from '@/interfaces/student';

import styles from './ParentProfileV2.module.scss';
import RelatedParentsCard from './RelatedParentsCard';

interface Props {
  student: Student;
  parents: RelatedParent[];
  currentUserId?: number;
}

const StudentCard: React.FC<Props> = ({ student, parents, currentUserId }) => (
  <article className={styles.ParentProfileV2__StudentCard}>
    <div className={styles.ParentProfileV2__StudentInformationCard}>
      <div className={styles.ParentProfileV2__StudentInfo}>
        <div className={styles.ParentProfileV2__StudentCodeRow}>
          <div className={styles.ParentProfileV2__StudentCodeLabel}>
            団体会員コード
          </div>
          <div className={styles.ParentProfileV2__StudentCodeValue}>
            <FormattedOrganizationMembershipCode code={student.code} />
          </div>
        </div>
        <div className={styles.ParentProfileV2__StudentDetailsRow}>
          <span className={styles.ParentProfileV2__StudentDetailItem}>
            {student.organization_name}
          </span>
          <span className={styles.ParentProfileV2__StudentDetailItem}>
            <GradeClassNumberLabel
              gradeLabel={student.grade}
              classNameLabel={student.class_name}
              attendanceNumberLabel={student.attendance_number}
            />
          </span>
          <span className={styles.ParentProfileV2__StudentDetailItem}>
            {student.name}
          </span>
        </div>
      </div>
    </div>
    <RelatedParentsCard
      parents={parents}
      student={student}
      currentUserId={currentUserId}
    />
  </article>
);

export default StudentCard;
